import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetGift: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 8h16v3H4zm1 3v8a1 1 0 001 1h12a1 1 0 001-1v-8m-8-3V5a3 3 0 00-3 3m3-3a3 3 0 013 3" />
      </svg>
    </div>
  );
};

export default WidgetGift;
